import React, { useState } from 'react';
import Constant from '../../../constants';
import "./slidermenu.scss";

const permit = Constant?.Permit;
const SliderMenu = (props) => {
    const { activeTab } = props;
    const [isMenu, setIsMenu] = useState("0");
    const [isOpen, setIsOpen] = useState(false);
    const [haveText, setHaveText] = useState(null);
    const menuClk = (e) => {
        const { name, id } = e?.target;
        setIsMenu(name ?? id)
        activeTab(name ?? id);
    }
    const handleClick = (e) => {
        if(!e){
            return false;
        }
        setIsOpen(!isOpen)
    }

    const itemList = props => {
        const list = props.map((item, index) => (
            <div
                onClick={menuClk}
                className="dropdown__item"
                key={item.toString()}
                id={index}
                >
                {item}
            </div>
        ));

        return (
            <div className="dropdown__items"> {list} </div>
        )
    }
    return (
        <>
            <nav className="mb menu">
                <ol className='menu-ol'>
                    <li className={isMenu === "0" ? "menu-item-active" : "menu-item"}>
                        <a onClick={menuClk} name="0" className={isMenu === "0" ? "active" : ""}>Aerial Activities</a>
                    </li>
                    <li className={isMenu === "1" ? "menu-item-active" : "menu-item"}>
                        <a onClick={menuClk} name="1" className={isMenu === "1" ? "active" : ""}>Aerial Mapping / Photography / Videography</a></li>
                    <li className={isMenu === "2" ? "menu-item-active" : "menu-item"}>
                        <a onClick={menuClk} name="2" className={isMenu === "2" ? "active" : ""}>Cranes and Tall Construction Machinery</a></li>
                    <li className={isMenu === "3" ? "menu-item-active" : "menu-item"}>
                        <a onClick={menuClk} name="3" className={isMenu === "3" ? "active" : ""}>Ship Crossing</a>
                    </li>
                    
                </ol>
            </nav>
            <div className='hide-permit-md'>
                <div
                    className={isOpen ? "dropdown active" : "dropdown"}
                    onClick={handleClick} >
                    <div className="dropdown__text">
                        {!haveText ? "Select Permit" : haveText}
                        <i className="bi bi-plus-lg ss-plus"></i>
                    </div>
                    
                    {itemList(permit)}
                </div>
            </div>
        </>
    );
}

export default SliderMenu;
